<div
  class="dropdown-trigger detailed"
  [class.session-conditions-trigger--unavailable]="!!unavailableReasonKey()"
  role="button"
  tabindex="0"
  [attr.aria-disabled]="!!unavailableReasonKey()"
  [matTooltip]="tooltip()"
  [matTooltipDisabled]="!tooltip()"
  matTooltipClass="multiline-tooltip"
  matTooltipPosition="above"
  matTooltipShowDelay="350"
  (click)="open($event)"
  (keydown.enter)="open($event)"
  (keydown.space)="open($event)"
  data-test="session-conditions-trigger">
  <div class="dropdown-trigger-body">
    <span class="dropdown-trigger-value">{{ title().key | translate: title().params }}</span>
    <span class="session-conditions-trigger__detail">
      @for (item of items(); track $index) {
        @if ($index > 0) {
          <span class="session-conditions-trigger__separator" aria-hidden="true">·</span>
        }
        @if (item.svgIcon) {
          <mat-icon class="session-conditions-trigger__icon" [svgIcon]="item.svgIcon"></mat-icon>
        } @else if (item.icon) {
          <mat-icon class="session-conditions-trigger__icon">{{ item.icon }}</mat-icon>
        }
        {{ item.text }}
      } @empty {
        {{ emptyDetailKey() | translate }}
      }
    </span>
  </div>
  <mat-icon class="dropdown-trigger-arrow">chevron_right</mat-icon>
</div>
